// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../common/Components/IconV5.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelayFooter_draft_graphql = require("../../../__generated__/PropertyWizardRelayFooter_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayFooter_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayFooter_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayFooter_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayFooter_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayFooter_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayFooter_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayFooter_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Footer(props) {
  let goToStep = props.goToStep;
  let goToPreview = props.goToPreview;
  let step = props.step;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayFooter_draft_graphql.node, convertFragment, props.draft);
  let lastStep = step === "photosAndFiles";
  let firstStep = step === "keyFacts";
  let goBack = () => {
    let match = draft.draftProperty.propertyType;
    let tmp;
    tmp = step === "description" ? "mlsTiming" : (
        step === "keyFacts" || step === "mlsTiming" ? "keyFacts" : (
            step === "photosAndFiles" ? (
                match === "FOR_SALE" ? "showings" : "mlsTiming"
              ) : "description"
          )
      );
    goToStep(tmp);
  };
  let goNext = () => {
    let match = draft.draftProperty.propertyType;
    let tmp;
    tmp = step === "description" ? (
        match === "FOR_SALE" ? "showings" : "photosAndFiles"
      ) : (
        step === "mlsTiming" ? "description" : (
            step === "keyFacts" ? "mlsTiming" : "photosAndFiles"
          )
      );
    goToStep(tmp);
  };
  return JsxRuntime.jsxs("div", {
    children: [
      lastStep ? JsxRuntime.jsx("div", {}) : JsxRuntime.jsxs(ButtonsV5.SecondaryButton.make, {
          onClick: param => goToPreview(),
          children: [
            JsxRuntime.jsx("span", {
              children: "Preview",
              className: "block sm:hidden"
            }),
            JsxRuntime.jsx("span", {
              children: "See preview",
              className: "hidden sm:block"
            })
          ]
        }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(ButtonsV5.PrimaryButton.make, {
            onClick: param => goBack(),
            disabled: firstStep,
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(IconV5.make, {
                  icon: "arrow-left"
                }),
                className: "mr-2 hidden md:block"
              }),
              "Back"
            ]
          }),
          lastStep ? JsxRuntime.jsxs(ButtonsV5.PrimaryButton.make, {
              onClick: param => goToPreview(),
              children: [
                "Preview",
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(IconV5.make, {
                    icon: "arrow-right"
                  }),
                  className: "ml-2 hidden md:block"
                })
              ]
            }) : JsxRuntime.jsxs(ButtonsV5.PrimaryButton.make, {
              onClick: param => goNext(),
              disabled: lastStep,
              children: [
                "Next",
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(IconV5.make, {
                    icon: "arrow-right"
                  }),
                  className: "ml-2 hidden md:block"
                })
              ]
            })
        ],
        className: "flex flex-row space-x-2"
      })
    ],
    className: "flex flex-row justify-between"
  });
}

let make = PropertyWizardRelay__Footer;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* IconV5 Not a pure module */
